import { Button } from "@mui/material";
import React from "react";

import { IStatusPanelParams } from "ag-grid-community";

export interface NewHeatStatusBarProps extends IStatusPanelParams {
	onNewHeat: () => void;
}

export interface NewHeatStatusBarProps {
	onNewHeat: () => void;
}

const NewHeatStatusBar = (props: NewHeatStatusBarProps) => {
	const { onNewHeat } = props;

	return (
		<div style={{ padding: "5px" }}>
			<Button variant="contained" color="primary" onClick={onNewHeat}>
				New Heat
			</Button>
		</div>
	);
};

export default NewHeatStatusBar;
